import { PlanCard } from "../cards/PlanCard";
import type { BeautyPlanPrices } from "../../types/pricing";
import type { BeautyPlan } from "../../features/beauty/beauty.types";

type PlanCarouselProps = {
  plans: BeautyPlan[];
  prices: BeautyPlanPrices;
  isAnnual: boolean;
};

export function PlanCarousel({ plans, prices, isAnnual }: PlanCarouselProps) {
  return (
    <div className="planos-grid reveal">
      {plans.map((plan) => (
        <PlanCard key={plan.id} plan={plan} prices={prices} isAnnual={isAnnual} />
      ))}
    </div>
  );
}
